export const changeLevel3NameReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_LEVEL3DATA_NAME":
      return action.payload.level3Data;
    default:
      return state;
  }
};
